import React from 'react'
import AdvertisementItem from "../Advertisements/AdvertisementItem"
import { WEISCHER } from '../constants/itemTypes'

const OverviewInterscroller = ({interscrollerType, interscrollerWeischerAds, interscrollerAdvertisements, styles, itemClass="order-wrapper"}) => {
    if(interscrollerType === WEISCHER)  {
        const { payload } = interscrollerWeischerAds[0]

        return (
            <div className={itemClass + " interscroller-item weischer-interscroller"} style={styles}>
                <div className="weischer-item-wrapper">
                    <div className="weischer-item" id={payload}></div>
                </div>
            </div>
        )

    } else {
        return (
            <div className={itemClass + " interscroller-item custom-placement-interscroller"} style={styles}>
                <AdvertisementItem
                    item={interscrollerAdvertisements[0]}
                    imageURLs={{mobile: false}}
                    itemOrigin="Overview Interscroller"
                />
            </div>
        )
    }
}

export default OverviewInterscroller